var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { isVersion, stringCompareTo } from "../../common/utils/common.utils.js";
class VariantBoundary {
  /// <summary>
  /// Initializes a new instance of the <see cref="VariantBoundary{T}"/> class.
  /// </summary>
  /// <param name="value">Constant literal value representing the boundary.</param>
  /// <param name="isClosed">True for closed intervals and false for open and half-open intervals.</param>
  constructor(value, isClosed, compareValues) {
    /// <summary>
    /// Gets the constant literal representing the boundary.
    /// </summary>
    __publicField(this, "value");
    /// <summary>
    /// Gets a value indicating whether <see cref="Value"/> is included (closed interval) or excluded (open interval).
    /// </summary>
    __publicField(this, "isClosed");
    __publicField(this, "_compareValues");
    this.value = value;
    this.isClosed = isClosed;
    this._compareValues = compareValues;
  }
  equals(obj) {
    return this.equalsInner(this, obj);
  }
  toString() {
    return this.isClosed ? `[${this.value}]` : `(${this.value})`;
  }
  equalsInner(x, y) {
    if (x === y) {
      return true;
    }
    if (x == null || y == null) {
      return false;
    }
    if (x.isClosed !== y.isClosed) {
      return false;
    }
    return VariantBoundary.compareValues(x.value, y.value, this._compareValues) === 0;
  }
  static compareValues(x, y, compare) {
    if (x === y) {
      return 0;
    }
    if (typeof x === "string" && typeof y === "string" && !isVersion(x) && !isVersion(y)) {
      const xString = x;
      const yString = y;
      return stringCompareTo(xString, yString);
    } else {
      return compare(x, y);
    }
  }
}
export {
  VariantBoundary
};
//# sourceMappingURL=VariantBoundary.js.map
